<template>
  <transition
    name="accordion"
    v-on:before-enter="beforeEnter"
    v-on:enter="enter"
    v-on:before-leave="beforeLeave"
    v-on:leave="leave"
  >
    <div
      class="e-accordion-body"
      v-show="show"
      :style="{ 'transition-duration': transition + 'ms' }"
    >
      <div class="e-accordion-body__body">
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    transition: {
      type: Number,
      default: 150,
    },
  },
  methods: {
    beforeEnter: function (el) {
      el.style.height = "0";
    },
    enter: function (el) {
      el.style.height = el.scrollHeight + "px";
    },
    beforeLeave: function (el) {
      el.style.height = el.scrollHeight + "px";
    },
    leave: function (el) {
      el.style.height = "0";
    },
  },
};
</script>

<style lang="scss">
.e-accordion-body {
  transition: 150ms ease-out;
  overflow: hidden;

  &__inner {
    overflow-wrap: break-word;
  }
}
</style>
